// Minimal RFC-4180-ish CSV parser (client-side import, §3). Handles quoted fields,
// escaped quotes ("") and CRLF/LF line endings.
export function parseCSV(text: string): string[][] {
  const rows: string[][] = [];
  let row: string[] = [];
  let field = "";
  let inQuotes = false;
  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    if (inQuotes) {
      if (c === '"') {
        if (text[i + 1] === '"') {
          field += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        field += c;
      }
    } else if (c === '"') {
      inQuotes = true;
    } else if (c === ",") {
      row.push(field);
      field = "";
    } else if (c === "\n" || c === "\r") {
      if (c === "\r" && text[i + 1] === "\n") i++;
      row.push(field);
      rows.push(row);
      row = [];
      field = "";
    } else {
      field += c;
    }
  }
  if (field !== "" || row.length > 0) {
    row.push(field);
    rows.push(row);
  }
  return rows.filter((r) => r.some((c) => c.trim() !== ""));
}

export interface CsvItem {
  name: string;
  username?: string;
  password?: string;
  url?: string;
  notes?: string;
}

// Map CSV rows to items using a header row. Recognizes common KeePass/Bitwarden columns.
export function rowsToItems(rows: string[][]): CsvItem[] {
  if (rows.length < 2) return [];
  const header = rows[0].map((h) => h.trim().toLowerCase());
  const idx = (...names: string[]) => header.findIndex((h) => names.includes(h));
  const ni = idx("name", "title", "account");
  const ui = idx("username", "user", "login", "login_name");
  const pi = idx("password", "pass");
  const li = idx("url", "uri", "website", "login_uri");
  const oi = idx("notes", "note", "comments");
  const out: CsvItem[] = [];
  for (let r = 1; r < rows.length; r++) {
    const row = rows[r];
    const name = (ni >= 0 ? row[ni] : row[0]) ?? "";
    if (!name.trim()) continue;
    out.push({
      name: name.trim(),
      username: ui >= 0 ? row[ui] : undefined,
      password: pi >= 0 ? row[pi] : undefined,
      url: li >= 0 ? row[li] : undefined,
      notes: oi >= 0 ? row[oi] : undefined,
    });
  }
  return out;
}
